import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const STYLES = {
    closeButtonPosition: 18,
    lottieContainerAspectRatio: "41 / 25",
};

export const CloseButton = styled.div`
    position: absolute;
    top: ${STYLES.closeButtonPosition}px;
    right: ${STYLES.closeButtonPosition}px;
`;

export const DataContainer = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xxLarge} ${theme.spacing.medium} calc(var(--sab, 0px) + ${theme.spacing.medium})`,
}));

export const TitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing.xxSmall,
}));

export const TitleText = styled(Text)(({ theme }) => ({
    marginRight: theme.spacing.xxxSmall,
}));

export const Subtitle = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.small,
}));

export const CtaContainer = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.small,
}));

export const SubTextContainer = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.small,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
}));

export const LottieContainer = styled.div(({ theme }) => ({
    display: "flex",
    overflow: "hidden",
    borderRadius: theme.cornerRadius.large,
    marginBottom: theme.spacing.xxxSmall,
    "button > div": {
        display: "flex",
    },
    button: {
        width: "100%",
    },
    aspectRatio: STYLES.lottieContainerAspectRatio,
    backgroundColor: theme.colors.light.background_Secondary,
}));
